import React from 'react'

export default function HTMLTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderImage = (section) => {
        return props.properties.head.logo.showLogo &&
            props.properties.head.logo.logo !== null ? (
            <div
                style={props.properties.head.logo.style}
                key={props.properties.head.logo.id || 'logo'}
                data-element={props.properties.head.logo.name || 'logo'}
                data-section={section}
                data-path="logo"
                data-index=""
            >
                <div>
                    <img
                        src={props.tempLogo ? props.tempLogo : props.properties.head.logo.logo}
                        style={{
                            width:
                                (props.properties
                                    ? props.properties.head.logo.logoSize
                                    : 100) + "%",
                            pointerEvents: "none",
                        }}
                        alt="Company Logo"
                    />
                </div>
            </div>
        ) : (
            <></>
        );
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                dStyle.color = dStyle.color || props.properties.prop.fontColor;
                dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={dStyle}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderVatSummary = () => {
        if (props.properties?.total?.VatSummary &&
            Object.keys(props.properties.total.VatSummary).length > 0) {
            var data = props.properties.total.VatSummary;
            var dStyle = Object.assign({}, data.style || {});
            dStyle.color = dStyle.color || props.properties.prop.fontColor;
            dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";

            const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || 'vat-summary');

            return (
                <div
                    key={data.id || 'vat-summary'}
                    style={dStyle}
                    id={data.id}
                    data-element={data.name || 'VatSummary'}
                    data-section="VatSummary"
                    data-path="elements"
                    data-index={dataIndex}
                >
                    {data.text || ''}
                </div>
            );
        }
        return null;
    };

    const renderShapes = (section) => {
        if (!props.properties[section]?.shapes) return null;

        return Object.keys(props.properties[section].shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties[section].shapes[key];
                if (!prop) return null;

                var borderColor = props.properties[section].shapes.border?.color || '#333333FF';
                var borderSize = props.properties[section].shapes.border?.size || 1;
                var bgColor = props.properties[section].shapes.border?.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, prop.style || {});
                dStyle.border = `${borderSize}px solid ${borderColor}`;
                dStyle.background = bgColor;
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={section}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    const renderCompanyElements = () => {
        if (!props.properties.head.companyProps) return null;

        return Object.keys(props.properties.head.companyProps).map((key) => {
            var prop = props.properties.head.companyProps[key];
            if (!prop || !prop.show) return null;

            var dStyle = Object.assign({}, prop.style || {});
            dStyle.color = dStyle.color || props.properties.prop.fontColor;
            dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";

            return (
                <div
                    key={key}
                    style={dStyle}
                    id={prop.id}
                    data-element={prop.name || 'company-prop'}
                    data-section={"head"}
                    data-path="companyProps"
                    data-index={prop.data || key}
                >
                    {prop.text || ''}
                </div>
            );
        });
    };

    const renderDocumentTitle = () => {
        var title = props.properties.head.documentTitle;
        if (!title || !title.show) return null;

        var dStyle = Object.assign({}, title.style || {});
        dStyle.color = dStyle.color || props.properties.prop.fontColor;
        dStyle.fontSize = dStyle.fontSize || "20pt";

        return (
            <div
                style={dStyle}
                key={title.id || 'doc-title'}
                id={title.id}
                data-element={title.name || 'document-title'}
                data-section={"head"}
                data-path="documentTitle"
                data-index={title.title || 'title'}
            >
                {title.title || 'INVOICE'}
            </div>
        );
    };

    const renderBodyElements = (displayData) => {
        return (
            <table
                style={{
                    marginLeft: props.properties.prop.margin?.left + 'in' || '0.5in',
                    marginRight: props.properties.prop.margin?.right + 'in' || '0.5in',
                    width: 'calc(100% - 1in)'
                }}
                cellSpacing={0}
                className="items-table"
            >
                <thead>
                    <tr>
                        {displayData.map((obj, key) => {
                            if (obj) {
                                const totalWidth = displayData.reduce((a, v) => a + Number(v?.width || 10), 0);
                                return (
                                    <th
                                        key={`dd_${key}`}
                                        width={obj.width ? (obj.width / totalWidth) * 100 + "%" : 'auto'}
                                        style={{
                                            padding: "10px 0px 10px 10px",
                                            textAlign: "left",
                                            backgroundColor: props.properties.items.layout.tableHeader.backgroundColor,
                                            fontSize: props.properties.items.layout.tableHeader.fontSize + "pt",
                                            fontFamily: props.properties.items.layout.tableHeader.fontFamily,
                                            color: props.properties.items.layout.tableHeader.fontColor,
                                        }}
                                    >
                                        {obj.stringFormat || obj.header}
                                    </th>
                                );
                            }
                            return null;
                        })}
                    </tr>
                </thead>
                {'{TableBodyContent}'}
            </table>
        );
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: props.properties.prop.orientation === "landscape" ? '1132px' : '800px',
            minHeight: '400px',
            backgroundColor: props.properties.prop.background.showColor
                ? props.properties.prop.background.color
                : "transparent",
        }}>
            <div>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>
                                <div style={{
                                    height: props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.height
                                }}>
                                    <div>
                                        {renderElements("head")}
                                        {renderImage("head")}
                                        {renderDocumentTitle()}
                                        {renderCompanyElements()}
                                        {renderShapes("head")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="items_table_conteiner">
                                    {renderBodyElements(
                                        Object.keys(props.properties.items.items)
                                            .map(key => props.properties.items.items[key])
                                            .filter(d => d && d.width !== undefined)
                                    )}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div
                                    style={{
                                        height: props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                                        position: 'relative',
                                        backgroundColor: props.properties.total.background.showColor
                                            ? props.properties.total.background.color
                                            : "transparent",
                                    }}
                                    className='total-section'
                                >
                                    <div>
                                        {renderElements("total")}
                                        {renderVatSummary()}
                                        {renderShapes("total")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div
                                    style={{
                                        height: props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                                        position: 'relative',
                                        backgroundColor: props.properties.foot.background.showColor
                                            ? props.properties.foot.background.color
                                            : "transparent",
                                    }}
                                    className='foot-section'
                                >
                                    <div>
                                        {renderElements("foot")}
                                        {renderShapes("foot")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}